// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__phiE2","description":"MealItem_description__B138r","price":"MealItem_price__4tCBO"};